<template>
  <div class="mb-6">
    <div class="bg-darkblue pa-2 font-weight-bold">{{ commande_inscription.get_entete() }}</div>
    <div v-if="commande_inscription.list_commandes_options.length > 0">
      <div class="text-h6 mt-3 mb-2">Déjà inclu pour cette inscription :</div>

      <div v-for="option in commande_inscription.list_commandes_options" :key="option.id">
        <div
          class="container_option_item d-flex flex-wrap justify-start align-center gap bordered rounded bg-grey_1 pa-1 mb-2">
          <div class="text-h6 ml-1" style="margin-right: auto">{{ option.nom }} <span
              v-if="option.size && option.size != ''">{{ option.size }}</span></div>
          <div class="d-flex flex-wrap align-center gap bg-white bordered pa-2 rounded justify-self-end">
            <div class="text-body-1">Quantité</div>
            <div class="text-h6">{{ option.quantite }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["commande_inscription"],
};
</script>

<style lang="scss" scoped></style>